import { ThemeColors } from "@insite/mobius/globals/baseTheme";
import { safeColor } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import RecursivePartial from "@insite/mobius/utilities/RecursivePartial";
import { css } from "styled-components";

export const fontFamily = "'Lato', sans-serif";

export const mediaQueriesBP = {
    maxSM: "@media screen and (max-width: 424px)",
    minSM: "@media screen and (min-width: 425px)",

    maxMD: "@media screen and (max-width: 767px)",
    minMD: "@media screen and (min-width: 768px)",

    maxLG: "@media screen and (max-width: 1023px)",
    minLG: "@media screen and (min-width: 1024px)",

    maxXLG: "@media screen and (max-width: 1199px)",
    minXLG: "@media screen and (min-width: 1200px)",

    minMDMaxLg: "@media screen and (min-width: 768px) and (max-width: 1023px)",
};

export const calcInitial = "calc((((100vw - (100vw - var(--width, 0))) - 100%) / 2) * -1)";

export const colorPalette: RecursivePartial<ThemeColors> = {
    primary: {
        main: "#094E66",
    },
    secondary: {
        main: "#DAE9ED",
    },
    common: {
        global: {
            white: "#fff",
            black: "#000",

            // Primary

            // Secondary

            // Grays
            gray01: "#25282A",
            gray02: "#676F7F",
            gray03: "#969A9D",
            gray04: "#DBE2E9",
            gray05: "#e5e5e5",
        },
    } as any,
};

export const colorStrings = {
    primaryMain: "primary.main",
    secondaryMain: "secondary.main",
    successMain: "success.main",
    dangerMain: "danger.main",
    warningMain: "warning.main",
    infoMain: "info.main",
    commonBackground: "common.background",
    commonBorder: "common.border",
    textMain: "text.main",
    textLink: "text.link",
    common: "common",
    commonDisabled: "common.disabled",

    commonGlobalWhite: "common.global.white",
    commonGlobalBlack: "common.global.black",
    commonGlobalGray01: "common.global.gray01",
    commonGlobalGray02: "common.global.gray02",
    commonGlobalGray03: "common.global.gray03",
    commonGlobalGray04: "common.global.gray04",
    commonGlobalGray05: "common.global.gray05",
};

export const manualStyles = {
    headerMobileSelected: css`
        background: #0032a040;
        background: ${safeColor(getColor(colorStrings.primaryMain)).rgb().alpha(0.25).toString()};
        color: #25282a;
        color: ${getColor(colorStrings.textMain)};
    `,
};

export const isWindows = () =>
    (typeof window !== "undefined" && window !== undefined && window.navigator.userAgent
        ? window.navigator.userAgent
        : ""
    ).indexOf("Windows") !== -1;
